(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glow-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__gmho) return;
    root.__gmho = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* hero slider */
    var hero = root.querySelector('[data-gmho-hero]');
    if (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.gmho-slide'));
      var bars = Array.prototype.slice.call(hero.querySelectorAll('[data-gmho-bar]'));
      var count = hero.querySelector('[data-gmho-count]');
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
      var auto = root.getAttribute('data-autoplay') === 'true' && !reduce && slides.length > 1;
      var i = 0, timer = null, held = false;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };

      var paint = function () {
        bars.forEach(function (b, k) {
          b.classList.remove('is-run', 'is-done', 'is-still');
          void b.offsetWidth;
          if (k < i) b.classList.add('is-done');
          if (k === i) b.classList.add(auto ? 'is-run' : 'is-still');
        });
        if (count) count.textContent = pad(i + 1) + ' / ' + pad(slides.length);
      };
      var arm = function () {
        clearTimeout(timer);
        if (auto && !held) timer = setTimeout(function () { go(i + 1); }, speed);
      };
      var go = function (n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          s.querySelectorAll('a').forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
        paint();
        arm();
      };
      var hold = function (on) {
        held = on;
        hero.classList.toggle('is-paused', on);
        if (on) clearTimeout(timer); else arm();
      };

      bars.forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-gmho-bar'), 10)); }); });
      var nx = hero.querySelector('[data-gmho-next]'), pv = hero.querySelector('[data-gmho-prev]');
      if (nx) nx.addEventListener('click', function () { go(i + 1); });
      if (pv) pv.addEventListener('click', function () { go(i - 1); });
      hero.addEventListener('mouseenter', function () { hold(true); });
      hero.addEventListener('mouseleave', function () { hold(false); });
      hero.addEventListener('focusin', function () { hold(true); });
      hero.addEventListener('focusout', function () { hold(false); });

      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var d = e.changedTouches[0].clientX - x0;
        if (Math.abs(d) > 40) go(i + (d < 0 ? 1 : -1));
        x0 = null;
      });

      root.__gmhoGo = function (n) { go(n); };
      root.__gmhoHold = hold;
      paint();
      arm();
    }

    /* instagram video wheel */
    var wheel = root.querySelector('[data-gmho-wheel]');
    if (wheel) {
      var cards = Array.prototype.slice.call(wheel.querySelectorAll('.gmho-card'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gmho-wdot]'));
      var n = cards.length, w = 0, inView = false, sound = false;
      var mq = window.matchMedia('(max-width: 749px)');

      var playActive = function () {
        cards.forEach(function (c, k) {
          var v = c.querySelector('video');
          if (!v) return;
          if (k === w && inView) {
            v.muted = !sound;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
            v.muted = true;
          }
          var m = c.querySelector('[data-gmho-mute]');
          if (m) { m.classList.toggle('is-on', k === w && sound); m.setAttribute('aria-label', k === w && sound ? 'Mute' : 'Unmute'); }
        });
      };

      var layout = function () {
        if (!n) return;
        var mobile = mq.matches, cw = cards[0].offsetWidth, gap = mobile ? 14 : 24, reach = mobile ? 1 : 3;
        cards.forEach(function (c, k) {
          var o = k - w;
          if (o > n / 2) o -= n;
          if (o < -n / 2) o += n;
          var a = Math.abs(o);
          var s = a === 0 ? 1 : Math.max(0.78, 0.9 - (a - 1) * 0.06);
          var x = o === 0 ? 0 : (o > 0 ? 1 : -1) * (cw / 2 + gap + (cw * s) / 2 + (a - 1) * (cw * s + gap * 0.8));
          c.style.transform = 'translateX(' + x + 'px) scale(' + s + ')';
          c.style.opacity = a > reach ? 0 : 1;
          c.style.filter = a === 0 ? 'none' : 'brightness(' + Math.max(0.35, 0.62 - (a - 1) * 0.12) + ') saturate(.8)';
          c.style.zIndex = 10 - a;
          c.style.pointerEvents = a > reach ? 'none' : 'auto';
          c.classList.toggle('is-active', a === 0);
          c.querySelectorAll('a, button').forEach(function (el) {
            if (a === 0) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
          });
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === w ? 'true' : 'false'); });
      };

      var wgo = function (k) { w = (k + n) % n; layout(); playActive(); };

      cards.forEach(function (c, k) {
        c.addEventListener('click', function (e) {
          if (!c.classList.contains('is-active')) { e.preventDefault(); wgo(k); }
        });
      });
      wheel.querySelectorAll('[data-gmho-mute]').forEach(function (m) {
        m.addEventListener('click', function (e) { e.stopPropagation(); sound = !sound; playActive(); });
      });
      dots.forEach(function (d) { d.addEventListener('click', function () { wgo(parseInt(d.getAttribute('data-gmho-wdot'), 10)); }); });
      var wn = wheel.querySelector('[data-gmho-wnext]'), wp = wheel.querySelector('[data-gmho-wprev]');
      if (wn) wn.addEventListener('click', function () { wgo(w + 1); });
      if (wp) wp.addEventListener('click', function () { wgo(w - 1); });
      wheel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') wgo(w + 1);
        if (e.key === 'ArrowLeft') wgo(w - 1);
      });

      var px = null, py = null;
      wheel.addEventListener('touchstart', function (e) { px = e.touches[0].clientX; py = e.touches[0].clientY; }, { passive: true });
      wheel.addEventListener('touchend', function (e) {
        if (px === null) return;
        var dx = e.changedTouches[0].clientX - px, dy = e.changedTouches[0].clientY - py;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) wgo(w + (dx < 0 ? 1 : -1));
        px = null;
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          playActive();
        }, { threshold: 0.35 }).observe(wheel);
      } else {
        inView = true;
      }

      window.addEventListener('resize', layout);
      if (mq.addEventListener) mq.addEventListener('change', layout);
      root.__gmhoWheel = wgo;
      layout();
      playActive();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-gmho]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target, root = el.closest && el.closest('[data-gmho]');
    if (root && el.classList.contains('gmho-card') && root.__gmhoWheel) {
      root.__gmhoWheel(parseInt(el.getAttribute('data-index'), 10));
      return;
    }
    if (!root || !el.classList.contains('gmho-slide')) return;
    if (root.__gmhoHold) root.__gmhoHold(true);
    if (root.__gmhoGo) root.__gmhoGo(parseInt(el.getAttribute('data-index'), 10));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest && e.target.closest('[data-gmho]');
    if (root && root.__gmhoHold) root.__gmhoHold(false);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
